import { CompanyMspInProductTrialsTabWebComponent } from './component/CompanyMspInProductTrialsTabWebComponent';
import { WEB_COMPONENT_COMPANY_MSP_IN_PRODUCT_TRIALS_TAB } from '../../../webcomponents.constants';

export { CompanyMspInProductTrialsTabWebComponent };

window.customElements.define(WEB_COMPONENT_COMPANY_MSP_IN_PRODUCT_TRIALS_TAB, CompanyMspInProductTrialsTabWebComponent);
